const HighSchool = () => {
    return (
        <div className="aboutMeContent">
			<h1 className="heading1">High School</h1>

			<p className="text">
                High School was a major part in my web development journey
            </p>

            <p className="text">
                The only programming teacher at my hich school, Mr. Patac
                was a major influence to my current passion in web development.
                He taught some fun courses going through the basics of HTML, CSS,
                JavaScript.
            </p>

            <p className="text">
                From there, I decided to also learn web development on my own. Then,
                I continued by pursuing a CS degree at Champlain College...
            </p>
		</div>
    )
}

export default HighSchool;